import React from 'react';
import { Skeleton, Stack } from '@mui/material';

const Line = (props) => <Skeleton
  data-testid='line-skeleton' sx={{ fontSize: '15px' }} {...props}
/>;

const Button = (props) => (
  <Skeleton
    data-testid='button-skeleton' variant='rounded' height='44px' width='270px' {...props}
  />
);

const DailySurveySkeleton = () => (
  <Stack>
    <Stack
      m='34px 0 37px 0' spacing='14px'>
      <Line />
      <Stack>
        <Line />
        <Line />
        <Line
          width='40%'
        />
      </Stack>
      <Line
        width='60%'
      />
    </Stack>
    <Button />
  </Stack>
);

export default DailySurveySkeleton;
